import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface PageTracking {
  page: string
  chartDepthViewed?: number
  chartName?: string
  totalCharts?: number
}

interface PageState {
  value: PageTracking | null
}

const initialState: PageState = { value: null }

const pageSlice = createSlice({
  name: 'page',
  initialState,
  reducers: {
    createPageTracking(state, action: PayloadAction<string>) {
      state.value = {
        page: action.payload,
      }
    },
    updateChartViewed(
      state,
      action: PayloadAction<{
        chartDepthViewed: number
        chartName: string
      }>
    ) {
      if (state.value) {
        const currentDepth = state.value.chartDepthViewed || 0
        if (action.payload.chartDepthViewed > currentDepth) {
          state.value = {
            ...state.value,
            ...action.payload,
          }
        }
      }
    },
    updateTotalCharts(
      state,
      action: PayloadAction<{
        totalCharts: number
      }>
    ) {
      if (state.value) {
        state.value = {
          ...state.value,
          ...action.payload,
        }
      }
    },
  },
})

export const { createPageTracking, updateChartViewed, updateTotalCharts } = pageSlice.actions
export default pageSlice.reducer
